import React from "react";
import styled from "styled-components";

const Marginbox = styled.div`
width: ${props => props.width}vw;
height: ${props => props.height}vh;
`;

export function Marginer(props){

    return(
        <Marginbox height={props.height} width={props.width}></Marginbox>
    )
}